import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppComponent } from './app.component';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';

import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { DashboardLayoutComponent } from './layouts/dashboard-layout/dashboard-layout.component';

import { LoginComponent } from './auth/pages/login/login.component';
import { RegisterComponent } from './auth/pages/register/register.component';
import { ForgotPasswordComponent } from './auth/pages/forgot-password/forgot-password.component';

import { FooterComponent } from './dashboard/components/footer/footer.component';
import { LanguageComponent } from './dashboard/components/language/language.component';
import { MenuComponent } from './dashboard/components/menu/menu.component';
import { NotificationComponent } from './dashboard/components/notification/notification.component';
import { UserLinkComponent } from './dashboard/components/user-link/user-link.component';
import { HomeComponent } from './dashboard/pages/home/home.component';
import { LoadingComponent } from './components/loading/loading.component';
import { CountryComponent } from './dashboard/pages/country/country.component';
import { UpdateModalComponent } from './dashboard/components/update-modal/update-modal.component';
import { SuccessAlertComponent } from './dashboard/components/success-alert/success-alert.component';
import { CardLoadingComponent } from './dashboard/components/card-loading/card-loading.component';
import { LoadingPanelComponent } from './components/loading-panel/loading-panel.component';
import { AlertComponent } from './components/alert/alert.component';
import { NotAuthorizedComponent } from './pages/not-authorized/not-authorized.component';
import { UserProfileComponent } from './dashboard/pages/user-profile/user-profile.component';
import { HelpCenterComponent } from './dashboard/pages/help-center/help-center.component';
import { ConfirmModalComponent } from './dashboard/components/confirm-modal/confirm-modal.component';
import { ChangePasswordComponent } from './dashboard/components/change-password/change-password.component';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { TemplateCustomizerComponent } from './components/template-customizer/template-customizer.component';
import { InsidePageNotFoundComponent } from './dashboard/components/inside-page-not-found/inside-page-not-found.component';
import { DataPickerComponent } from './dashboard/components/data-picker/data-picker.component';
import { DatePipe } from '@angular/common';
import { VersionTagComponent } from './dashboard/components/version-tag/version-tag.component';
import { TourComponent } from './components/tour/tour.component';
import { TranslateDataPipe } from './pipe/translate-data.pipe';
import { MultiSelectDropdownComponent } from './dashboard/components/multi-select-dropdown/multi-select-dropdown.component';
import { FileDropComponent } from './dashboard/components/file-drop/file-drop.component';
import { DialogConfirmComponent } from './dashboard/components/dialog-confirm/dialog-confirm.component';
import { PrivacyPolicyComponent } from './auth/pages/privacy-policy/privacy-policy.component';
import { BalancePreviewComponent } from './dashboard/components/balance-preview/balance-preview.component';
import { APIDocumentaionComponent } from './dashboard/pages/apidocumentaion/apidocumentaion.component';
import { JsonDataPipe } from './pipe/json-data.pipe';
import { CurlDataPipe } from './pipe/curl-data.pipe';
import { MenuModelComponent } from './dashboard/pages/menu-model/menu-model.component';
import { PCardAlertComponent } from './dashboard/components/pcard-alert/pcard-alert.component';
import { PCardHelpButtonComponent } from './dashboard/components/pcard-help-button/pcard-help-button.component';
import { PCardControlBoxComponent } from './dashboard/components/pcard-control-box/pcard-control-box.component';
import { PCardHeaderComponent } from './dashboard/components/pcard-header/pcard-header.component';
import { PCardCreateButtonComponent } from './dashboard/components/pcard-create-button/pcard-create-button.component';
import { PCardPrintButtonComponent } from './dashboard/components/pcard-print-button/pcard-print-button.component';
import { PCardEditColumnButtonComponent } from './dashboard/components/pcard-edit-column-button/pcard-edit-column-button.component';
import { PCardReloadButtonComponent } from './dashboard/components/pcard-reload-button/pcard-reload-button.component';
import { PCardTableComponent } from './dashboard/components/pcard-table/pcard-table.component';
import { TableHeaderPipe } from './pipe/table-header';
import { NormalLenghtPipe } from './pipe/normal-lenght.pipe';
import { PPageBreadCrumbComponent } from './dashboard/components/ppage-bread-crumb/ppage-bread-crumb.component';
import { PCardTableSortabelButtonComponent } from './dashboard/components/pcard-table-sortabel-button/pcard-table-sortabel-button.component';
import { TreeViewComponent } from './dashboard/components/tree-view/tree-view.component';
import { CityComponent } from './dashboard/pages/city/city.component';
import { DoctorComponent } from './dashboard/pages/doctor/doctor.component';
import { BankComponent } from './dashboard/pages/bank/bank.component';
import { CashDeskComponent } from './dashboard/pages/cash-desk/cash-desk.component';
import { CheckComponent } from './dashboard/pages/check/check.component';
import { CompanyComponent } from './dashboard/pages/company/company.component';
import { DrugComponent } from './dashboard/pages/drug/drug.component';
import { DrugFormComponent } from './dashboard/pages/drug-form/drug-form.component';
import { InsurancesComponent } from './dashboard/pages/insurances/insurances.component';
import { TechnicalRightComponent } from './dashboard/pages/technical-right/technical-right.component';
import { PatientComponent } from './dashboard/pages/patient/patient.component';
import { DrugStoreComponent } from './dashboard/pages/drug-store/drug-store.component';
import { DrugUsageComponent } from './dashboard/pages/drug-usage/drug-usage.component';
import { BankAccountComponent } from './dashboard/pages/bank-account/bank-account.component';
import { DoctorSpecialtyComponent } from './dashboard/pages/doctor-specialty/doctor-specialty.component';
import { KeepingTypeComponent } from './dashboard/pages/keeping-type/keeping-type.component';
import { PersianHolidayComponent } from './dashboard/pages/persian-holiday/persian-holiday.component';
import { PhonebookComponent } from './dashboard/pages/phonebook/phonebook.component';
import { SellerComponent } from './dashboard/pages/seller/seller.component';
import { UserComponent } from './dashboard/pages/user/user.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DisableDirective } from './attribute/DisableDirective';
import { BuyComponent } from './dashboard/pages/buy/buy.component';
import { PCTableComponent } from './dashboard/components/pctable/pctable.component';
import { PCCrudComponent } from './dashboard/components/pccrud/pccrud.component';
import { PCPagingComponent } from './dashboard/components/pcpaging/pcpaging.component';
import { PCTableActionComponent } from './dashboard/components/pctable-action/pctable-action.component';
import { PCEditModalComponent } from './dashboard/components/pcedit-modal/pcedit-modal.component';
import { PCConfrimModalComponent } from './dashboard/components/pcconfrim-modal/pcconfrim-modal.component';
import { PCSuccessModalComponent } from './dashboard/components/pcsuccess-modal/pcsuccess-modal.component';
import { PCBreadCrumbComponent } from './dashboard/components/pcbread-crumb/pcbread-crumb.component';
import { StockComponent } from './dashboard/pages/stock/stock.component';
import { SaleComponent } from './dashboard/pages/sale/sale.component';
import { PctableStockComponent } from './dashboard/components/pctable-stock/pctable-stock.component';
import { DataTypePipe } from './pipe/data-type.pipe';
import { CheckbookComponent } from './dashboard/pages/checkbook/checkbook.component';
import { PositionComponent } from './dashboard/pages/position/position.component';
import { DrugGenericComponent } from './dashboard/pages/drug-generic/drug-generic.component';
import { CheckBookTypeComponent } from './dashboard/pages/check-book-type/check-book-type.component';
import { CheckBookCountComponent } from './dashboard/pages/check-book-count/check-book-count.component';
import { AdminStockComponent } from './dashboard/pages/admin-stock/admin-stock.component';
import { PctableBuyFactorComponent } from './dashboard/components/pctable-buy-factor/pctable-buy-factor.component';
import { FastSaleComponent } from './dashboard/pages/fast-sale/fast-sale.component';
import { WarehouseHandlingModalComponent } from './dashboard/components/warehouse-handling-modal/warehouse-handling-modal.component';
import { CalenderComponent } from './dashboard/components/calender/calender.component';
import { TaminAuthorizComponent } from './dashboard/pages/tamin-authoriz/tamin-authoriz.component';
import { DropDownComponent } from './components/drop-down/drop-down.component';
import { DrugDistributorComponent } from './dashboard/pages/drug-distributor/drug-distributor.component';
import { CashPayComponent } from './dashboard/components/cash-pay/cash-pay.component';
import { CreditPayComponent } from './dashboard/components/credit-pay/credit-pay.component';
import { EssentialsComponent } from './dashboard/pages/essentials/essentials.component';
import { NaturalRemedyComponent } from './dashboard/pages/natural-remedy/natural-remedy.component';
import { SupplementComponent } from './dashboard/pages/supplement/supplement.component';
import { CosmeticComponent } from './dashboard/pages/cosmetic/cosmetic.component';
import { MilkPowderComponent } from './dashboard/pages/milk-powder/milk-powder.component';
import { TraditionalDrugComponent } from './dashboard/pages/traditional-drug/traditional-drug.component';
import {
  CdkDragDrop,
  CdkDropList,
  CdkDrag,
  moveItemInArray,
} from '@angular/cdk/drag-drop';
import { SearchBoxComponent } from './dashboard/components/search-box/search-box.component';
import { SelectOnFocusDirective } from './pipe/select-on-focus.directive';
import { SaleFactorComponent } from './dashboard/components/sale-factor/sale-factor.component';
import { ClickOutsideDirective } from './pipe/click-outside.directive';
import { SalePrintFactorComponent } from './dashboard/components/sale-print-factor/sale-print-factor.component';
import { ReturnModalComponent } from './dashboard/components/return-modal/return-modal.component';
import { BuyPreInvoiceComponent } from './dashboard/pages/buy-pre-invoice/buy-pre-invoice.component';
import { RemoveLackComponent } from './dashboard/components/remove-lack/remove-lack.component';
import { CashMultiPaymentComponent } from './dashboard/components/cash-multi-payment/cash-multi-payment.component';
import { BarcodeComponent } from './dashboard/components/barcode/barcode.component';
import { FontSizeAdjusterDirective } from './services/font-size-adjuster.directive';
import { CreditMultiPaymentComponent } from './dashboard/components/credit-multi-payment/credit-multi-payment.component';
import { ElectronicPrescriptionComponent } from './dashboard/pages/electronic-prescription/electronic-prescription.component';
import { TruncatePipe } from './pipe/truncate';
import { ChangeDrugSupportComponent } from './dashboard/pages/change-drug-support/change-drug-support.component';
import { ScanBarcodeModalComponent } from './dashboard/components/scan-barcode-modal/scan-barcode-modal.component';
import { SalesReportComponent } from './dashboard/pages/sales-report/sales-report.component';
import { DropDownPagingComponent } from './components/drop-down-paging/drop-down-paging.component';
import { ReportCalenderComponent } from './dashboard/pages/report-calender/report-calender.component';
import { DrugGroupComponent } from './dashboard/pages/drug-group/drug-group.component';
import { TransferBetweenStockComponent } from './dashboard/pages/transfer-between-stock/transfer-between-stock.component';
import { WarehouseHandlingComponent } from './dashboard/pages/warehouse-handling/warehouse-handling.component';
import { WarehouseHandlingDetailComponent } from './dashboard/pages/warehouse-handling-detail/warehouse-handling-detail.component';
import { ChangePricingComponent } from './dashboard/pages/change-pricing/change-pricing.component';
import { LiveDateTimeComponent } from './dashboard/components/live-date-time/live-date-time.component';
import { SalamatProductComponent } from './dashboard/components/salamat-product/salamat-product.component';
import { PcsettingModalComponent } from './dashboard/components/pcsetting-modal/pcsetting-modal.component';
import { WarehouseHandlingReportComponent } from './dashboard/pages/warehouse-handling-report/warehouse-handling-report.component';
import { FactorReportComponent } from './dashboard/pages/factor-report/factor-report.component';
import { DrugModalComponent } from './dashboard/components/drug-modal/drug-modal.component';
import {
  NgxMaskConfig,
  NgxMaskDirective,
  NgxMaskPipe,
  provideNgxMask,
} from 'ngx-mask';
import { PersianDatePipe } from './pipe/persian-data.pipe';
import { SaleListComponent } from './dashboard/pages/sale-list/sale-list.component';
import { FactorListComponent } from './dashboard/pages/factor-list/factor-list.component';
import { LoadingItemComponent } from './components/loading-item/loading-item.component';
import { SaleCosmeticComponent } from './dashboard/pages/sale-cosmetic/sale-cosmetic.component';
import { InsuranceReportComponent } from './dashboard/pages/insurance-report/insurance-report.component';
import { PersianDateTimePipe } from './pipe/persian-data-time.pipe';
import { UserAccountSettingComponent } from './dashboard/pages/user-account-setting/user-account-setting.component';
import { CheckoutComponent } from './dashboard/pages/checkout/checkout.component';
import { PosDeviceComponent } from './dashboard/pages/pos-device/pos-device.component';
import { DatamatrixBarcodeComponent } from './components/datamatrix-barcode/datamatrix-barcode.component';
import { BarcodeGeneratorComponent } from './dashboard/pages/barcode-generator/barcode-generator.component';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { BarcodeScannerComponent } from './dashboard/components/barcode-scanner/barcode-scanner.component';
import { ConvertNumbersDirective } from './pipe/convert-numbers.directive';
import { POSTypeComponent } from './dashboard/pages/postype/postype.component';
import { ChangePasswordModalComponent } from './dashboard/components/change-password-modal/change-password-modal.component';
import { PermissionModalComponent } from './dashboard/components/permission-modal/permission-modal.component';
import { MatTreeModule } from '@angular/material/tree';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FactorTableComponent } from './dashboard/components/factor-table/factor-table.component';
import { SalePreInvoiceComponent } from './dashboard/pages/sale-pre-invoice/sale-pre-invoice.component';
import { SaleTableComponent } from './dashboard/components/sale-table/sale-table.component';
import { FastWarehouseHandlingComponent } from './dashboard/pages/fast-warehouse-handling/fast-warehouse-handling.component';
import { InventoryReconciliationComponent } from './dashboard/pages/inventory-reconciliation/inventory-reconciliation.component';
import { ScanBarcodeModalSalamatComponent } from './dashboard/components/scan-barcode-modal-salamat/scan-barcode-modal-salamat.component';
import { InventoryTransferComponent } from './dashboard/pages/inventory-transfer/inventory-transfer.component';
import { DigitalPrescriptionSalamatComponent } from './dashboard/components/digital-prescription-salamat/digital-prescription-salamat.component';
import { ScarceDrugComponent } from './dashboard/pages/scarce-drug/scarce-drug.component';
import { RareDrugComponent } from './dashboard/pages/rare-drug/rare-drug.component';

const maskConfig: Partial<NgxMaskConfig> = {
  validation: false,
};

@NgModule({
  declarations: [
    AppComponent,

    PageNotFoundComponent,
    AuthLayoutComponent,
    DashboardLayoutComponent,

    LoginComponent,
    RegisterComponent,
    ForgotPasswordComponent,

    FooterComponent,
    LanguageComponent,
    MenuComponent,
    NotificationComponent,
    UserLinkComponent,

    HomeComponent,
    LoadingComponent,
    CountryComponent,
    UpdateModalComponent,
    SuccessAlertComponent,
    CardLoadingComponent,
    LoadingPanelComponent,
    AlertComponent,
    NotAuthorizedComponent,
    UserProfileComponent,
    HelpCenterComponent,
    ConfirmModalComponent,
    ChangePasswordComponent,
    TemplateCustomizerComponent,
    InsidePageNotFoundComponent,
    DataPickerComponent,
    VersionTagComponent,
    FactorReportComponent,
    TourComponent,
    TranslateDataPipe,
    MultiSelectDropdownComponent,
    FileDropComponent,
    DialogConfirmComponent,
    PrivacyPolicyComponent,
    BalancePreviewComponent,
    APIDocumentaionComponent,
    JsonDataPipe,
    TableHeaderPipe,
    NormalLenghtPipe,
    CurlDataPipe,
    MenuModelComponent,
    PCardAlertComponent,
    PCardHelpButtonComponent,
    PCardControlBoxComponent,
    PCardHeaderComponent,
    PCardCreateButtonComponent,
    PCardPrintButtonComponent,
    PCardEditColumnButtonComponent,
    PCardReloadButtonComponent,
    PCardTableComponent,
    PPageBreadCrumbComponent,
    PCardTableSortabelButtonComponent,
    TreeViewComponent,
    CityComponent,
    DoctorComponent,
    BankComponent,
    CashDeskComponent,
    CheckComponent,
    CompanyComponent,
    DrugComponent,
    DrugFormComponent,
    InsurancesComponent,
    TechnicalRightComponent,
    PatientComponent,
    DrugStoreComponent,
    DrugUsageComponent,
    BankAccountComponent,
    DoctorSpecialtyComponent,
    KeepingTypeComponent,
    PersianHolidayComponent,
    PhonebookComponent,
    SellerComponent,
    UserComponent,
    DisableDirective,
    BuyComponent,
    PCTableComponent,
    PCCrudComponent,
    PCPagingComponent,
    PCTableActionComponent,
    PCEditModalComponent,
    PCConfrimModalComponent,
    PCSuccessModalComponent,
    PCBreadCrumbComponent,
    StockComponent,
    SaleComponent,
    PctableStockComponent,
    DataTypePipe,
    CheckbookComponent,
    PositionComponent,
    DrugGenericComponent,
    CheckBookTypeComponent,
    CheckBookCountComponent,
    AdminStockComponent,
    PctableBuyFactorComponent,
    FastSaleComponent,
    CalenderComponent,
    WarehouseHandlingModalComponent,
    TaminAuthorizComponent,
    DropDownComponent,
    DrugDistributorComponent,
    CashPayComponent,
    CreditPayComponent,
    EssentialsComponent,
    NaturalRemedyComponent,
    SupplementComponent,
    CosmeticComponent,
    MilkPowderComponent,
    TraditionalDrugComponent,
    SearchBoxComponent,
    SelectOnFocusDirective,
    SaleFactorComponent,
    ClickOutsideDirective,
    SalePrintFactorComponent,
    ReturnModalComponent,
    BuyPreInvoiceComponent,
    RemoveLackComponent,
    CashMultiPaymentComponent,
    CreditMultiPaymentComponent,
    BarcodeComponent,
    FontSizeAdjusterDirective,
    ElectronicPrescriptionComponent,
    TruncatePipe,
    ChangeDrugSupportComponent,
    ScanBarcodeModalComponent,
    ScanBarcodeModalSalamatComponent,
    SalesReportComponent,
    DropDownPagingComponent,
    ReportCalenderComponent,
    DrugGroupComponent,
    TransferBetweenStockComponent,
    WarehouseHandlingComponent,
    WarehouseHandlingDetailComponent,
    ChangePricingComponent,
    LiveDateTimeComponent,
    SalamatProductComponent,
    PcsettingModalComponent,
    WarehouseHandlingReportComponent,
    DrugModalComponent,
    PersianDatePipe,
    PersianDateTimePipe,
    SaleListComponent,
    FactorListComponent,
    LoadingItemComponent,
    SaleCosmeticComponent,
    UserAccountSettingComponent,
    InsuranceReportComponent,
    CheckoutComponent,
    PosDeviceComponent,
    DatamatrixBarcodeComponent,
    BarcodeGeneratorComponent,
    BarcodeScannerComponent,
    ConvertNumbersDirective,
    POSTypeComponent,
    FactorTableComponent,
    ChangePasswordModalComponent,
    PermissionModalComponent,
    SalePreInvoiceComponent,
    SaleTableComponent,
    FastWarehouseHandlingComponent,
    InventoryTransferComponent,
    InventoryReconciliationComponent,
    ScarceDrugComponent,
    RareDrugComponent,
    DigitalPrescriptionSalamatComponent
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    NgbModule,
    CdkDrag,
    CdkDropList,
    BrowserAnimationsModule,
    MatFormFieldModule,
    MatInputModule,
    ZXingScannerModule,
    MatSelectModule,
    NgxMaskDirective,
    NgxMaskPipe,
    MatTreeModule,
    MatButtonModule,
    MatIconModule,
    MatCheckboxModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [provideNgxMask(), DatePipe, PersianDatePipe, PersianDateTimePipe],
  bootstrap: [AppComponent],
})
export class AppModule {}

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}
